import React from 'react';
import './contact.scss';

export function Contact() {
  return (
    <section id="contact">
      <h2 className='contact-title'>Контакты</h2>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 center">
          <p className="pattaya fn org">«Наоли»</p>
          <p><span className="category">ветеринарная клиника</span></p>
          <p className="lead adr"><span className="locality">Янино-1</span>, <br />
          <span className="street-address">Шоссейная улица, дом 77</span></p>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 center">
          <p>Режим работы: <span className="workhours">с 10:00 до 22:00</span></p>
          <p>Способы оплаты: наличные/по карте</p>
          <p>тел.: <a href="tel:88129213626"><span className="contact-tel">+7 (812) 921 36 26</span></a></p>
          <p>email: <a href="mailto:naoli-vet@mail.ru"><span className="email">naoli-vet@mail.ru</span></a></p>
          <span className="url">
            <span className="value-title" title="http://naoli-vet.com"></span>
          </span>
        </div>
        <div className='map'>
          <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Aaa90e241f90dbdba26bc5a8357fc77f288ef53f9b40d1e4a7429c40a9c30c271&amp;source=constructor" width="100%" height="300" title="yamap"></iframe>
        </div>
      </div>
    </section>
  );
}
